import {
    type SubEventUploadTokenRequestType,
    type UploadTokenResponseType
} from "./type";
import {
    request
} from "../request";

const GetUploadTokenForSubEventLogo = async (params: SubEventUploadTokenRequestType): Promise<UploadTokenResponseType> => {
    return await request<UploadTokenResponseType>("/events/getUploadTokenForSubEventLogo", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default GetUploadTokenForSubEventLogo;
